/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");
import { mmenu } from "./partials/mmenu.js";
import { slider } from "./partials/slider.js";
import { inview } from "./partials/inview.js";

/*************************************************/
/* Partials                                      */
/*************************************************/
import { news } from "./partials/news.js";
import { video } from "./partials/video.js";
import { header } from "./partials/header.js";
import { modal } from "./partials/modal.js";

/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading";

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {
    mmenu();
    slider();
    inview();
    news($body, bodyLoadingClass);
    video();
    header($body);
    modal($body, bodyLoadingClass);
});